/**
 * Update tie format with modifications.
 * Compares and persists changes to tournament tie format configuration.
 */
import { tournamentEngine, queryGovernor } from 'tods-competition-factory';
import { mutationRequest } from 'services/mutation/mutationRequest';
import { tmxToast } from 'services/notifications/tmxToast';
import { editTieFormat } from './editTieFormat';
import { isFunction } from 'functions/typeOf';
import { t } from 'i18n';

import { MODIFY_TIE_FORMAT } from 'constants/mutationConstants';

export function updateTieFormat({
  matchUpId,
  structureId,
  eventId,
  drawId,
  callback,
}: {
  matchUpId?: string;
  structureId?: string;
  eventId?: string;
  drawId?: string;
  callback?: () => void;
}): void {
  const { tieFormat } = tournamentEngine.getTieFormat({
    structureId,
    matchUpId,
    eventId,
    drawId,
  });

  const updateTieFormat = (modifiedTieFormat: any) => {
    if (modifiedTieFormat) {
      modifiedTieFormat.collectionDefinitions?.forEach((def: any, i: number) => (def.collectionOrder = i + 1));

      const considerations = { collectionName: true, collectionOrder: true };
      const different = queryGovernor.compareTieFormats({
        descendant: modifiedTieFormat,
        ancestor: tieFormat,
        considerations,
      })?.different;

      if (!different) {
        tmxToast({ intent: 'is-info', message: t('overlays.tieFormat.noChanges') });
        return;
      }

      const methods = [
        {
          method: MODIFY_TIE_FORMAT,
          params: {
            modifiedTieFormat,
            considerations,
            structureId,
            matchUpId,
            drawId,
          },
        },
      ];

      const postMutation = (result: any) => {
        if (result.success) {
          tmxToast({ intent: 'is-success', message: t('overlays.tieFormat.scorecardUpdated') });
          return isFunction(callback) && callback?.();
        } else {
          return tmxToast({ intent: 'is-danger', message: result.error?.message || t('common.error') });
        }
      };
      mutationRequest({ methods, callback: postMutation });
    }
  };

  editTieFormat({ title: t('overlays.tieFormat.editScorecard'), tieFormat, onClose: updateTieFormat });
}
